module.exports = __webpack_public_path__ + "img/map4.9f5f4e18.png";